import React from 'react'
import { Icon } from '@manychat/manyui'

import cm from './styles.module.css'

interface SystemMessageProps {
  text: string
}

export const SystemMessage = React.forwardRef<HTMLLIElement, SystemMessageProps>(
  ({ text }, ref) => {
    return (
      <li className={cm.wrapper} ref={ref}>
        <span />

        <div className={cm.background}>
          <div className={cm.message}>
            <Icon.Ai className={cm.message__icon} size={12} />

            <span className={cm.message__content}>{text}</span>
          </div>
        </div>

        <span />
      </li>
    )
  },
)
